import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function Dashboard() {
  const [accounts, setAccounts] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [bills, setBills] = useState([]);
  const [journalEntries, setJournalEntries] = useState([]);

  useEffect(() => {
    api(`/accounts`).then(r => r.json()).then(setAccounts).catch(() => {});
    api(`/invoices`).then(r => r.json()).then(setInvoices).catch(() => {});
    api(`/bills`).then(r => r.json()).then(setBills).catch(() => {});
    api(`/journal-entries`).then(r => r.json()).then(setJournalEntries).catch(() => {});
  }, []);

  const openInvoices = invoices.filter(i => i.status === 'SENT' || i.status === 'OVERDUE');
  const openBills = bills.filter(b => b.status === 'RECEIVED' || b.status === 'OVERDUE');
  const totalReceivable = openInvoices.reduce((sum, i) => sum + (i.total || 0), 0);
  const totalPayable = openBills.reduce((sum, b) => sum + (b.total || 0), 0);

  const StatCard = ({ title, value, color }) => (
    <div className="bg-white rounded-lg shadow p-6">
      <p className="text-sm text-gray-500 mb-1">{title}</p>
      <p className={`text-2xl font-bold ${color || 'text-gray-900'}`}>{value}</p>
    </div>
  );

  return (
    <Layout>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
        <StatCard title="Total Accounts" value={accounts.length} />
        <StatCard title="Journal Entries" value={journalEntries.length} />
        <StatCard title="Accounts Receivable" value={`$${totalReceivable.toLocaleString(undefined, {minimumFractionDigits: 2})}`} color="text-emerald-600" />
        <StatCard title="Accounts Payable" value={`$${totalPayable.toLocaleString(undefined, {minimumFractionDigits: 2})}`} color="text-red-600" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow">
          <div className="p-4 md:p-6 border-b flex justify-between items-center">
            <h2 className="text-lg font-semibold text-gray-900">Recent Invoices</h2>
            <Link to="/accounting/invoices" className="text-emerald-600 hover:text-emerald-800 text-sm font-medium">View All</Link>
          </div>
          <div className="divide-y">
            {invoices.slice(0, 5).map(inv => (
              <Link key={inv.id} to={`/accounting/invoices/${inv.id}`} className="block px-6 py-3 hover:bg-gray-50">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium text-gray-900">{inv.invoiceNumber}</p>
                    <p className="text-sm text-gray-500">{inv.companyName || inv.contactName || '—'}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold text-gray-900">${(inv.total || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}</p>
                    <span className={`text-xs px-2 py-1 rounded-full ${inv.status === 'PAID' ? 'bg-green-100 text-green-800' : inv.status === 'OVERDUE' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'}`}>{inv.status}</span>
                  </div>
                </div>
              </Link>
            ))}
            {invoices.length === 0 && <div className="text-center py-8 text-gray-500">No invoices yet.</div>}
          </div>
        </div>

        <div className="bg-white rounded-lg shadow">
          <div className="p-4 md:p-6 border-b flex justify-between items-center">
            <h2 className="text-lg font-semibold text-gray-900">Recent Bills</h2>
            <Link to="/accounting/bills" className="text-emerald-600 hover:text-emerald-800 text-sm font-medium">View All</Link>
          </div>
          <div className="divide-y">
            {bills.slice(0, 5).map(bill => (
              <Link key={bill.id} to={`/accounting/bills/${bill.id}`} className="block px-6 py-3 hover:bg-gray-50">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-medium text-gray-900">{bill.billNumber}</p>
                    <p className="text-sm text-gray-500">{bill.companyName || bill.contactName || '—'}</p>
                  </div>
                  <div className="text-right">
                    <p className="font-semibold text-gray-900">${(bill.total || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}</p>
                    <span className={`text-xs px-2 py-1 rounded-full ${bill.status === 'PAID' ? 'bg-green-100 text-green-800' : bill.status === 'OVERDUE' ? 'bg-red-100 text-red-800' : 'bg-gray-100 text-gray-800'}`}>{bill.status}</span>
                  </div>
                </div>
              </Link>
            ))}
            {bills.length === 0 && <div className="text-center py-8 text-gray-500">No bills yet.</div>}
          </div>
        </div>
      </div>
    </Layout>
  );
}
